module.exports = __webpack_public_path__ + "assets/img/search.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/search.png
// module id = 700
// module chunks = 0